import React, { memo, useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import CampoObrigatorio from '../../../../components/UI/CampoObrigatorio/CampoObrigatorio';
import Grid24 from '../../../../components/UI/Grid24';
import { getRequiredLabel } from '../../../../helpers/utils/utils';
import {
  getFieldName,
  makeErrorField,
} from '../../../../helpers/utils/form.utils';
import { dialogEmailController } from './dialogEmailController';
import { TextareaField } from '../../../../components';
import useStyle from '../EmailsProcessoStyles';

function DialogEmail({ onClose, setLoadings, updatePage, idProcesso }) {
  const utilStyle = useStyle();

  const [formFields, setFormFields] = useState(
    dialogEmailController.makeFormFields()
  );
  const [errorFields, setErrorFields] = useState(
    dialogEmailController.makeErrorFields()
  );

  const QTD_PALAVRAS_MINIMAS = 5;

  const onChangeHandler = useCallback((e) => {
    const name = getFieldName(e.target);
    const { value } = e.target;
    setFormFields((oldValue) => ({
      ...oldValue,
      [name]: { ...oldValue[name], value },
    }));
  }, []);

  const onFocusHandler = useCallback((e) => {
    const name = getFieldName(e.target);
    setErrorFields((oldValues) => ({
      ...oldValues,
      [name]: makeErrorField(),
    }));
  }, []);

  const onCloseDialog = useCallback(() => {
    onClose();
    setFormFields(dialogEmailController.makeFormFields());
    setErrorFields(dialogEmailController.makeErrorFields());
  }, [onClose]);

  const [contagemDePalavras, setContagemDePalavras] = useState(0);

  const countWords = useCallback((text) => {
    if (!text || !text.trim()) return 0;
    return text.trim().split(/\s+/).length;
  }, []);

  const isButtonDisabled = contagemDePalavras < QTD_PALAVRAS_MINIMAS;

  const cadastrarMensagemDeEmail = useCallback(
    async (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      setLoadings(true);
      try {
        await dialogEmailController.registrarEmail(idProcesso, formFields);
        if (updatePage) {
          await updatePage();
        }
        onCloseDialog();
        toast.success('E-mail registrado com sucesso!');
      } catch (error) {
        const validations = error?.response?.data?.validations;
        if (validations && validations.length > 0) {
          toast.error(
            error?.response?.data?.error || 'Erro ao registrar email',
            {
              style: { width: '392px' },
            }
          );
          validations.forEach((validation) => {
            setErrorFields((errFields) => ({
              ...errFields,
              [validation.field]: {
                error: true,
                errorMessage: validation.message,
              },
            }));
          });
        } else {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            'Erro ao registrar email';
          toast.error(errorMessage, { style: { width: '392px' } });
        }
      } finally {
        setLoadings(false);
      }
    },
    [idProcesso, formFields, updatePage, onCloseDialog, setLoadings]
  );

  useEffect(() => {
    const novaContagem = countWords(formFields?.email?.value || '');
    setContagemDePalavras(novaContagem);
  }, [formFields?.email?.value, countWords]);

  return (
    <>
      {errorFields.email.error === true && <CampoObrigatorio />}
      <Grid24 container isFormContainer spacing="1">
        <Grid24 item xs={24} sm={24}>
          <TextareaField
            label={getRequiredLabel('E-mail', true)}
            placeholder="Inserir texto do e-mail"
            readOnly={false}
            name="email"
            classForm={utilStyle.areaSize}
            value={formFields?.email?.value || ''}
            onFocus={onFocusHandler}
            onChange={onChangeHandler}
            error={errorFields.email.error}
            errorMessage={errorFields.email.errorMessage}
          />
        </Grid24>
      </Grid24>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '10px',
        }}
      >
        <Button onClick={onCloseDialog}>Cancelar</Button>
        <Button onClick={cadastrarMensagemDeEmail} disabled={isButtonDisabled}>
          Confirmar
        </Button>
      </div>
    </>
  );
}
export default memo(DialogEmail);
